// extracted by mini-css-extract-plugin
export var carrierIcon = "_w6-0";
export var carrierLogo = "_w6-1";
export var detailsSection = "_w6-2";